/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "clearmdrestapi",
            "endpoint": "https://5hh32psqcj.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:9cf094ba-e18a-4ec0-9da1-dcab9a57f5bd",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_xWEiyCukZ",
    "aws_user_pools_web_client_id": "5tr0i2j5km836hl60u71uss0ab",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "appointments",
            "region": "us-east-1"
        },
        {
            "tableName": "patients",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "clearmdresults",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
